const Loader = () => (
    <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{ minHeight: "300px" }}
    >
        <div className="text-center">
            <div className="spinner-border text-primary mb-2" role="status" />
            <div className="text-muted">Завантаження транзакцій…</div>
        </div>
    </div>
);

export default Loader
